var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form__group" },
    [
      _c("label", { staticClass: "form__label", attrs: { for: "event" } }, [
        _vm._v("Event"),
      ]),
      _vm._v(" "),
      _c(
        "multiselect",
        {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'",
            },
          ],
          class: {
            form__control: true,
            "form__control--invalid": _vm.errors.first(this.name),
          },
          attrs: {
            name: "event",
            options: _vm.results,
            placeholder: _vm.placeholder,
            "allow-empty": _vm.allowEmpty,
            label: "eventName",
            "track-by": "id",
            loading: _vm.loading,
          },
          on: { input: _vm.updateValue },
          model: {
            value: _vm.selected,
            callback: function ($$v) {
              _vm.selected = $$v
            },
            expression: "selected",
          },
        },
        [
          _vm._v("\n        >\n        "),
          _c("span", { attrs: { slot: "noOptions" }, slot: "noOptions" }, [
            _vm._v("Type a name to search users..."),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form__validation" }, [
        _vm._v(_vm._s(_vm.errors.first("event"))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }